import { createContext, useContext, ReactNode, useState, useCallback } from 'react'

export interface CommandPaletteActions {
  openNewSite?: () => void
  showAddCustomer?: () => void
  showAddStock?: () => void
  createOutwardChallan?: () => void
  createInwardChallan?: () => void
  receiveLost?: () => void
  showAddPayment?: () => void
  showOtherCharge?: () => void
  showCreateMonthlyBill?: () => void
  showCreateSaleInvoice?: () => void
  siteTransfer?: () => void
  showReceiveExcess?: () => void
  handleLogout?: () => void
}

const defaultActions: CommandPaletteActions = {
  openNewSite: () => {},
  showAddCustomer: () => {},
  showAddStock: () => {},
  createOutwardChallan: () => {},
  createInwardChallan: () => {},
  receiveLost: () => {},
  showAddPayment: () => {},
  showOtherCharge: () => {},
  showCreateMonthlyBill: () => {},
  showCreateSaleInvoice: () => {},
  siteTransfer: () => {},
   showReceiveExcess: () => {},
  handleLogout: () => {},
}

const CommandPaletteContext = createContext<CommandPaletteActions>(defaultActions)
const CommandPaletteActionsContext = createContext<{
  setActions: (actions: CommandPaletteActions) => void
}>({
  setActions: () => {},
})

export const useCommandPaletteActions = () => useContext(CommandPaletteContext)
export const useCommandPaletteActionsSetter = () => useContext(CommandPaletteActionsContext)

interface CommandPaletteProviderProps {
  children: ReactNode
}

export function CommandPaletteProvider({ children }: CommandPaletteProviderProps) {
  const [actions, setActions] = useState<CommandPaletteActions>(defaultActions)

  const updateActions = useCallback((newActions: CommandPaletteActions) => {
    setActions(newActions)
  }, [])

  return (
    <CommandPaletteActionsContext.Provider value={{ setActions: updateActions }}>
      <CommandPaletteContext.Provider value={actions}>
        {children}
      </CommandPaletteContext.Provider>
    </CommandPaletteActionsContext.Provider>
  )
}

